export enum RegistrationType {
  Unknown = 0,
  Sorenson = 1,
  Other = 2,
  NotRegistered = 3,
  Emergency = 4,
  Provisional = 5,
}
